// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import RecentScansController from "./recent_scans_controller"
application.register("recent-scans", RecentScansController)
